var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "handle-box" },
        [
          _c(
            "el-form",
            {
              ref: "queryCondition",
              staticClass: "searchForm",
              attrs: { "label-width": "140px", model: _vm.queryCondition },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("storeFeedback.feedbackNo"),
                                    prop: "feedbackNo",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "handle-input",
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      placeholder: "单据编号",
                                    },
                                    model: {
                                      value: _vm.queryCondition.feedbackNo,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "feedbackNo",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "queryCondition.feedbackNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("storeFeedback.storeNo"),
                                    prop: "storeNo",
                                  },
                                },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      staticClass: "handle-input",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        clearable: "",
                                        placeholder: "餐厅国际编号",
                                      },
                                      model: {
                                        value: _vm.queryCondition.storeNo,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "storeNo",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "queryCondition.storeNo",
                                      },
                                    },
                                    [
                                      _c("el-divider", {
                                        attrs: {
                                          slot: "suffix",
                                          direction: "vertical",
                                        },
                                        slot: "suffix",
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-search el-input_icon pointerCss",
                                        attrs: { slot: "suffix" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showSelStoreDialogMethod(
                                              "no"
                                            )
                                          },
                                        },
                                        slot: "suffix",
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("storeFeedback.storeName"),
                                    prop: "storeName",
                                  },
                                },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      staticClass: "handle-input",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        clearable: "",
                                        placeholder: "餐厅名称",
                                      },
                                      model: {
                                        value: _vm.queryCondition.storeName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "storeName",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "queryCondition.storeName",
                                      },
                                    },
                                    [
                                      _c("el-divider", {
                                        attrs: {
                                          slot: "suffix",
                                          direction: "vertical",
                                        },
                                        slot: "suffix",
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-search el-input_icon pointerCss",
                                        attrs: { slot: "suffix" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showSelStoreDialogMethod(
                                              "name"
                                            )
                                          },
                                        },
                                        slot: "suffix",
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("storeFeedback.creator"),
                                    prop: "createName",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "handle-input",
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      placeholder: "填表人",
                                    },
                                    model: {
                                      value: _vm.queryCondition.createName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "createName",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "queryCondition.createName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-collapse-transition",
                    [
                      _vm.isShow
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "storeFeedback.dcName"
                                            ),
                                            prop: "dcName",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-input",
                                            {
                                              staticClass: "handle-input",
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                clearable: "",
                                                placeholder: "发货DC",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition.dcName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "dcName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.dcName",
                                              },
                                            },
                                            [
                                              _c("el-divider", {
                                                attrs: {
                                                  slot: "suffix",
                                                  direction: "vertical",
                                                },
                                                slot: "suffix",
                                              }),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-search el-input_icon pointerCss",
                                                attrs: { slot: "suffix" },
                                                on: {
                                                  click:
                                                    _vm.showSelDcDialogMethod,
                                                },
                                                slot: "suffix",
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "storeFeedback.supplier"
                                            ),
                                            prop: "supplierName",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-input",
                                            {
                                              staticClass: "handle-input",
                                              staticStyle: { width: "100%" },
                                              attrs: { clearable: "" },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .supplierName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "supplierName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.supplierName",
                                              },
                                            },
                                            [
                                              _c("el-divider", {
                                                attrs: {
                                                  slot: "suffix",
                                                  direction: "vertical",
                                                },
                                                slot: "suffix",
                                              }),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-search el-input_icon pointerCss",
                                                attrs: { slot: "suffix" },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.showSelSupplierDialog = true
                                                  },
                                                },
                                                slot: "suffix",
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "storeFeedback.materialName"
                                            ),
                                            prop: "materialName",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "handle-input",
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              clearable: "",
                                              placeholder: "产品名称",
                                            },
                                            model: {
                                              value:
                                                _vm.queryCondition.materialName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "materialName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.materialName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "storeFeedback.feedbackChannel"
                                            ),
                                            prop: "sourceCode",
                                          },
                                        },
                                        [
                                          _c("ic-select", {
                                            staticClass: "handle-input",
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              clearable: "",
                                              table: "TT_FEEDBACK",
                                              field: "QUERY_SOURCE_CODE",
                                            },
                                            model: {
                                              value:
                                                _vm.queryCondition.sourceCode,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "sourceCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.sourceCode",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "storeFeedback.status"
                                            ),
                                            prop: "processNode",
                                          },
                                        },
                                        [
                                          _c("ic-select", {
                                            staticClass: "handle-input",
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              clearable: "",
                                              excludes: _vm.excludesValue,
                                              table: "TT_FEEDBACK",
                                              field: _vm.fieldValue,
                                            },
                                            model: {
                                              value:
                                                _vm.queryCondition.processNode,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "processNode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.processNode",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "storeFeedback.problemLevel"
                                            ),
                                            prop: "problemLevel",
                                          },
                                        },
                                        [
                                          _c("ic-select", {
                                            staticClass: "handle-input",
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              clearable: "",
                                              table: "TT_FEEDBACK_FIRST_CHECK",
                                              field: "PROBLEM_LEVEL",
                                            },
                                            model: {
                                              value:
                                                _vm.queryCondition.problemLevel,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "problemLevel",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.problemLevel",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "Category Level1",
                                            prop: "categoryLevel1Code",
                                          },
                                        },
                                        [
                                          _c("ic-select", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              table: "BASE",
                                              filterable: "",
                                              field: "CATEGORY_LEVEL1",
                                              clearable: "",
                                            },
                                            on: {
                                              change: function ($event) {
                                                _vm.queryCondition.categoryLevel2Code =
                                                  null
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.queryCondition
                                                  .categoryLevel1Code,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "categoryLevel1Code",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.categoryLevel1Code",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "Category Level2",
                                            prop: "categoryLevel2Code",
                                          },
                                        },
                                        [
                                          _c("ic-select", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              table: "BASE",
                                              filterable: "",
                                              field:
                                                _vm.queryCondition
                                                  .categoryLevel1Code,
                                              clearable: "",
                                              multiple: "",
                                            },
                                            model: {
                                              value:
                                                _vm.queryCondition
                                                  .categoryLevel2Code,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "categoryLevel2Code",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.categoryLevel2Code",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "餐厅提交日期(从)",
                                            prop: "createDateFrom",
                                          },
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              type: "date",
                                              placeholder:
                                                _vm.$t("common.selDate"),
                                              "value-format": "yyyy-MM-dd",
                                            },
                                            model: {
                                              value:
                                                _vm.queryCondition
                                                  .createDateFrom,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "createDateFrom",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.createDateFrom",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "餐厅提交日期(至)",
                                            prop: "createDateTo",
                                          },
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              type: "date",
                                              placeholder:
                                                _vm.$t("common.selDate"),
                                              "value-format": "yyyy-MM-dd",
                                            },
                                            model: {
                                              value:
                                                _vm.queryCondition.createDateTo,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "createDateTo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.createDateTo",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "接到反馈日期(从)",
                                            prop: "commitDateFrom",
                                          },
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              type: "date",
                                              placeholder:
                                                _vm.$t("common.selDate"),
                                              "value-format": "yyyy-MM-dd",
                                            },
                                            model: {
                                              value:
                                                _vm.queryCondition
                                                  .commitDateFrom,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "commitDateFrom",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.commitDateFrom",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "接到反馈日期(至)",
                                            prop: "commitDateTo",
                                          },
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              type: "date",
                                              placeholder:
                                                _vm.$t("common.selDate"),
                                              "value-format": "yyyy-MM-dd",
                                            },
                                            model: {
                                              value:
                                                _vm.queryCondition.commitDateTo,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "commitDateTo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.commitDateTo",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center", align: "middle" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.queryData(1)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.search")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.restQueryFormThis()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.reset")))]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "arrowDown",
                      on: {
                        click: function ($event) {
                          _vm.isShow = !_vm.isShow
                        },
                      },
                    },
                    [
                      _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                      _c("i", {
                        class: _vm.isShow
                          ? "el-icon-arrow-up iconBtn"
                          : "el-icon-arrow-down iconBtn",
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "action-btn-row" },
        [
          _vm.isStoreFbc
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.FeedbacksNew,
                      expression: "FeedbacksNew",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addStoreFeedback(-99999)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.addNew")))]
              )
            : _vm._e(),
          _vm.isStoreFbc
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.FeedbacksSuspend,
                      expression: "FeedbacksSuspend",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "danger" },
                  on: { click: _vm.stopStoreFeedback },
                },
                [_vm._v(_vm._s(_vm.$t("common.stop")))]
              )
            : _vm._e(),
          _vm.isStoreFbc
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.FeedbacksCopy,
                      expression: "FeedbacksCopy",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.copyStoreFeedback },
                },
                [_vm._v(_vm._s(_vm.$t("common.copy")))]
              )
            : _vm._e(),
          _vm.isSupplier
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.FeedbacksCreateReport,
                      expression: "FeedbacksCreateReport",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.createNewReport },
                },
                [_vm._v(_vm._s(_vm.$t("storeFeedback.report.createReport")))]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "acl",
                  rawName: "v-acl",
                  value: _vm.FeedbacksExport,
                  expression: "FeedbacksExport",
                },
              ],
              staticClass: "btn",
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.exportExcel },
            },
            [_vm._v(_vm._s(_vm.$t("common.export")))]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "dataTable",
          attrs: {
            data: _vm.tableData,
            border: "",
            "highlight-current-row": "",
            "max-height": "420",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              fixed: "",
              width: "56",
              label: _vm.$t("common.select"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-radio",
                      {
                        attrs: { label: scope.row.ttFeedbackId },
                        nativeOn: {
                          change: function ($event) {
                            return _vm.getSelectRow(scope.row)
                          },
                        },
                        model: {
                          value: _vm.radioVal,
                          callback: function ($$v) {
                            _vm.radioVal = $$v
                          },
                          expression: "radioVal",
                        },
                      },
                      [_vm._v(" ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              fixed: "",
              "min-width": "120px",
              sortable: "",
              prop: "feedbackNo",
              align: "center",
              label: _vm.$t("storeFeedback.feedbackNo"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "a-link",
                        on: {
                          click: function ($event) {
                            return _vm.showDetail(scope.row.ttFeedbackId)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.feedbackNo))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              "min-width": "160px",
              sortable: "",
              prop: "supplierName",
              align: "center",
              label: _vm.$t("storeFeedback.supplier"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              "min-width": "130px",
              sortable: "",
              prop: "materialName",
              align: "center",
              label: _vm.$t("storeFeedback.materialName"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              "min-width": "90px",
              sortable: "",
              prop: "problemLevel",
              align: "center",
              label: _vm.$t("storeFeedback.problemLevel"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              "min-width": "90px",
              sortable: "",
              prop: "isRepeat",
              align: "center",
              label: _vm.$t("storeFeedback.isRepeat"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              "min-width": "110px",
              sortable: "",
              prop: "createDate",
              align: "center",
              label: _vm.$t("storeFeedback.createDate"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("dateFormatFilter")(
                            scope.row.createDate,
                            "YYYY-MM-DD"
                          )
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              "min-width": "130px",
              sortable: "",
              prop: "storeName",
              align: "center",
              label: _vm.$t("storeFeedback.storeName"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              "min-width": "110px",
              sortable: "",
              prop: "processNode",
              align: "center",
              label: _vm.$t("storeFeedback.status"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              "min-width": "90px",
              sortable: "",
              prop: "consumeTypeI18n",
              align: "center",
              label: _vm.$t("storeFeedback.consumeType"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              "min-width": "100px",
              sortable: "",
              prop: "productionDate",
              align: "center",
              label: _vm.$t("storeFeedback.productDate"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("dateFormatFilter")(
                            scope.row.productionDate,
                            "YYYY-MM-DD"
                          )
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              "min-width": "90px",
              sortable: "",
              prop: "dcName",
              align: "center",
              label: _vm.$t("storeFeedback.dcName"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              "min-width": "90px",
              sortable: "",
              prop: "materialCode",
              align: "center",
              label: _vm.$t("storeFeedback.materialCode"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              "min-width": "140px",
              sortable: "",
              prop: "categoryLevel2Name",
              align: "center",
              label: "Category Level2",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              "min-width": "90px",
              sortable: "",
              prop: "sourceCodeI18n",
              align: "center",
              label: _vm.$t("storeFeedback.feedbackChannel"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              "min-width": "90px",
              sortable: "",
              prop: "reportTypeI18n",
              align: "center",
              label: _vm.$t("storeFeedback.reportType"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              "min-width": "160px",
              sortable: "",
              prop: "storeNo",
              align: "center",
              label: _vm.$t("storeFeedback.storeNo"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              "min-width": "90px",
              sortable: "",
              prop: "isDirectSaleI18n",
              align: "center",
              label: _vm.$t("storeFeedback.isDirectSale"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              "min-width": "90px",
              sortable: "",
              prop: "createName",
              align: "center",
              label: _vm.$t("storeFeedback.creator"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              "min-width": "90px",
              sortable: "",
              prop: "auditor",
              align: "center",
              label: _vm.$t("storeFeedback.auditor"),
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.queryCondition.pageNum,
              "page-sizes": _vm.pageSizeList,
              "page-size": _vm.queryCondition.pageSize,
              layout: _vm.pageLayout,
              total: _vm.totalCount,
            },
            on: {
              "size-change": _vm.pageSizeChange,
              "current-change": _vm.pageNumberChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSelSupplierDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelSupplierDialog = $event
            },
          },
        },
        [
          _c("plant-sel-page", {
            ref: "supplierSelRef",
            attrs: { multipleSelectionFlag: false },
            on: { subCallMethod: _vm.selectSupplierMethod },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSelStoreDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelStoreDialog = $event
            },
          },
        },
        [
          _c("SelStore", {
            ref: "selectStoreRef",
            attrs: { multipleSelectionFlag: false },
            on: { subCallMethod: _vm.selectStoreMethod },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSelDcDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelDcDialog = $event
            },
          },
        },
        [
          _c("SelDc", {
            ref: "selectDcRef",
            attrs: {
              multipleSelectionFlag: false,
              disabledStatusFlag: false,
              type: new Array("DC", "DIRECT_SUPPLIER"),
            },
            on: { subCallMethod: _vm.selectDcMethod },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSelMaterialDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelMaterialDialog = $event
            },
          },
        },
        [
          _c("SelMaterial", {
            ref: "selectMaterialRef",
            attrs: { multipleSelectionFlag: false },
            on: { subCallMethod: _vm.selectMaterialMethod },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }